<template>
  <div class="section">
  	Results
  </div>
</template>

<script>
export default {
  name: 'results'
}
</script>
